// Primero importamos las dependencias
import React from 'react'; // Importa React
import ReactDOM from 'react-dom/client'; // Importa ReactDOM
import { BrowserRouter as Router } from 'react-router-dom'; // Importa BrowserRouter
import './index.css'; // Estilo de la app
import App from './App'; // Importa el componente principal
import 'leaflet/dist/leaflet.css';
//redux config BEGIN
import store from "./redux/store";
import { Provider } from "react-redux";
//redux config END

// Luego renderizamos la aplicación
ReactDOM.createRoot(document.getElementById('root')).render(

  <Provider store={store}>
    <Router> {/* Envolvemos la aplicación con Router */}
      <App />
    </Router>
  </Provider>
);





